import Container from '@/components/templates/container'
import MainImage from './mainImage'
import Content from './content'

const Community = ({ title, description, image, ctaButton }) => {
  const base =
    'flex flex-col lg:flex-row justify-between gap-smallMobile lg:gap-mediumDesktop'
  return (
    <Container
      outerClassName="my-largeMobile lg:my-largeDesktop"
      className={base}
    >
      <Content title={title} description={description} ctaButton={ctaButton} />
      <MainImage image={image} />
    </Container>
  )
}

export default Community
